var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtificial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M118,321.6V386h12v-62.8c-4,0.4-2.8,0.8-4,0.8C122.8,324,118,323.2,118,321.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M126,296c1.6,0,0,0.4,4,0.8V222h-12v76.4C118,296.8,122.8,296,126,296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M192,364.8c2,0,2,0.4,6,1.2v-32h-16v34.4C182,366,188,364.8,192,364.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M382,298.4c0-1.6,5.2-2.8,8-2.8c1.2,0,0,0.4,4,0.4v-74h-12V298.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 158,
    style: {
      fill: "#E8E3E3"
    },
    width: 100,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M198,422v-27.2c-4,0.8-4,1.2-6,1.2c-3.6,0-10-1.6-10-3.6V422H198z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M382,321.2V386h12v-62.4c-4,0.4-2.4,0.4-4,0.4C387.2,324,382,323.2,382,321.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M330,422v-27.2c-4,0.8-3.6,1.2-6,1.2c-4,0-10-1.6-10-4v29.6h16V422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M324,364.8c2,0,2,0.4,6,1.2v-32h-16v34.4C314,366,320.4,364.8,324,364.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M162.4,38c-3.6,0-8.4,1.6-8.4,5.2v69.6c0,4,4.4,9.2,8.4,9.2h3.6V38L162.4,38L162.4,38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33A5D2"
    },
    d: "M150,316c0,7.6,5.6,14,13.2,14h184c7.6,0,14.8-6.4,14.8-14v-10H150V316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M337.2,126h-4H170v14c0,7.6,5.6,14,13.2,14h144c7.6,0,14.8-6.4,14.8-14v-14H337.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M327.2,6h-2h-142c-7.6,0-13.2,6.4-13.2,14v106h172V22v-2C342,12.4,334.8,6,327.2,6z M217.2,88.4 c-10,0-18-8-18-18s8-18,18-18s18,8,18,18S227.2,88.4,217.2,88.4z M297.6,88.4c-10,0-18-8-18-18s8-18,18-18s18,8,18,18 S307.6,88.4,297.6,88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M358,112.8V43.2c0-4-2-5.2-6-5.2h-6v84h6C356,122,358,116,358,112.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC52F"
    },
    d: "M217.2,56c-7.6,0-14,6.4-14,14s6.4,14,14,14s14-6.4,14-14S224.8,56,217.2,56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC52F"
    },
    d: "M297.6,56c-7.6,0-14,6.4-14,14s6.4,14,14,14s14-6.4,14-14S305.2,56,297.6,56z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M150,502h80c0-4,0-10.4,0-16l0,0h-80V502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M150,474.4V486h80v-11.6c0-8-5.2-12.4-12.8-12.4h-52C157.6,462,150,466.8,150,474.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AEB1B4"
    },
    cx: 191.2,
    cy: 380.4,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8E3E3"
    },
    cx: 125.2,
    cy: 310,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 426,
    style: {
      fill: "#33A5D2"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M282,502h80c0-4,0-10.4,0-16l0,0h-80V502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M282,474.4V486h80v-11.6c0-8-5.2-12.4-12.8-12.4h-52C289.6,462,282,466.8,282,474.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M323.2,392c6.4,0,11.6-5.2,11.6-11.6s-5.2-11.6-11.6-11.6c-6.4,0-11.6,5.2-11.6,11.6 C311.6,386.8,316.8,392,323.2,392z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 426,
    style: {
      fill: "#33A5D2"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC52F"
    },
    d: "M257.2,279.6c18.4,0,33.6-15.2,33.6-33.6s-15.2-33.6-33.6-33.6s-33.6,15.2-33.6,33.6 S238.4,279.6,257.2,279.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M347.2,182H346v74c0,1.2-1.6,2-2.8,2h-2H308c-0.4,0-1.2-0.4-1.6-0.8c-0.4-0.4-0.4-0.8-0.4-1.6l0.4-2 c0.4-2.8,0.4-4.4,0.4-6.8c0-27.6-22.4-50.4-49.6-50.4s-49.6,22.4-49.6,50c0,2.4,0.4,4.4,0.4,7.6v1.2c0,0.4,0,1.2-0.4,1.6 s-0.8,0.8-1.6,0.8h-38.8c-1.2,0-1.2-0.8-1.2-2V182h-2.8c-7.6,0-13.2,6.4-13.2,14v4v20v86h212v-84v-2v-18v-2v-2v-2 C362,188.4,354.8,182,347.2,182z M257.2,283.6c-20.8,0-37.6-16.8-37.6-37.6s16.8-37.6,37.6-37.6s37.6,16.8,37.6,37.6 S277.6,283.6,257.2,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33A5D2"
    },
    d: "M204,254c-0.4-2.8-0.4-4.8-0.4-7.2c0-30,24-54,53.6-54s53.6,24.4,53.6,54.4c0,2.4,0,4-0.4,6.8H342 v-72H170v72L204,254L204,254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M107.6,209.6c0,4.4,4.8,8.4,7.6,8.4H146v-16h-30.8C112.4,202,107.6,205.6,107.6,209.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33A5D2"
    },
    d: "M135.2,388.8c-1.2-0.4-0.8,1.2-2,1.2h-14c-3.2,0-9.2-1.2-9.2,2v16c0,3.2,6,10,9.2,10h16 c3.2,0,2.8-6.8,2.8-10v-14C138,390.8,138,390.4,135.2,388.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8E3E3"
    },
    cx: 389.2,
    cy: 310,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEB1B4"
    },
    d: "M395.2,218c2.8,0,7.6-4,7.6-8.4s-4.8-7.6-7.6-7.6H366v16H395.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33A5D2"
    },
    d: "M399.2,388.8c-1.2-0.4-0.8,1.2-2,1.2h-12h-2c-0.8,0-2.8-2-3.6-1.6c-2.4,0.8-5.6,1.2-5.6,3.6v16 c0,3.2,6,10,9.2,10h16c3.2,0,2.8-6.8,2.8-10v-14C402,390.8,402,390.4,399.2,388.8z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348,336H164c-11.2,0-20-8.8-20-20V196c0-11.2,8.8-20,20-20h184c11.2,0,20,8.8,20,20v120C368,327.2,359.2,336,348,336z  M164,184c-6.8,0-12,5.2-12,12v120c0,6.8,5.2,12,12,12h184c6.8,0,12-5.2,12-12V196c0-6.8-5.2-12-12-12H164z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M328,160H184c-11.2,0-20-8.8-20-20V20c0-11.2,8.8-20,20-20h144c11.2,0,20,8.8,20,20v120C348,151.2,339.2,160,328,160z  M184,8c-6.8,0-12,5.2-12,12v120c0,6.8,5.2,12,12,12h144c6.8,0,12-5.2,12-12V20c0-6.8-5.2-12-12-12H184z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170,128h-7.6c-7.2,0-14.4-7.6-14.4-15.2V43.2c0-6.8,6-11.2,14.4-11.2h3.6c2.4,0,4,1.6,4,4s-1.6,4-4,4h-3.6 c-1.6,0-6.4,0.8-6.4,3.2v69.6c0,3.2,3.6,7.2,6.4,7.2h7.6c2.4,0,4,1.6,4,4S172.4,128,170,128z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M352,128h-6c-2.4,0-4-1.6-4-4s1.6-4,4-4h6c2.4,0,4-3.6,4-7.2V43.2c0-2.4-0.4-3.2-4-3.2h-6c-2.4,0-4-1.6-4-4s1.6-4,4-4h6 c7.6,0,12,4.4,12,11.2v69.6C364,120.4,359.6,128,352,128z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.2,90.4c-11.2,0-20-9.2-20-20c0-11.2,9.2-20,20-20c11.2,0,20,9.2,20,20C237.2,81.6,228.4,90.4,217.2,90.4z M217.2,58 c-6.8,0-12,5.6-12,12s5.6,12,12,12s12-5.6,12-12S224,58,217.2,58z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6,90.4c-11.2,0-20-9.2-20-20c0-11.2,9.2-20,20-20c11.2,0,20,9.2,20,20C317.6,81.6,308.8,90.4,297.6,90.4z M297.6,58 c-6.8,0-12,5.6-12,12s5.6,12,12,12c6.8,0,12-5.6,12-12S304.4,58,297.6,58z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232,508h-84c-2.4,0-4-1.6-4-4v-29.6c0-11.6,10.8-18.4,21.2-18.4h52c11.2,0,18.8,7.6,18.8,18.4V504 C236,506.4,234.4,508,232,508z M152,500h76v-25.6c0-6.4-4-10.4-10.8-10.4h-52c-6.4,0-13.2,3.6-13.2,10.4V500z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.2,398c-9.6,0-17.6-8-17.6-17.6s8-17.6,17.6-17.6s17.6,8,17.6,17.6S200.8,398,191.2,398z M191.2,370.8 c-5.2,0-9.6,4.4-9.6,9.6s4.4,9.6,9.6,9.6c5.2,0,9.6-4.4,9.6-9.6S196.4,370.8,191.2,370.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.2,326c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16S134,326,125.2,326z M125.2,302c-4.4,0-8,3.6-8,8s3.6,8,8,8 s8-3.6,8-8S129.6,302,125.2,302z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208,462c-2.4,0-4-1.6-4-4v-30h-28v30c0,2.4-1.6,4-4,4s-4-1.6-4-4v-34c0-2.4,1.6-4,4-4h36c2.4,0,4,1.6,4,4v34 C212,460.4,210.4,462,208,462z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180,426c-2.4,0-4-1.6-4-4v-32c0-2.4,1.6-4,4-4s4,1.6,4,4v32C184,424.4,182.4,426,180,426z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M200,426c-2.4,0-4-1.6-4-4v-28c0-2.4,1.6-4,4-4s4,1.6,4,4v28C204,424.4,202.4,426,200,426z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180,374c-2.4,0-4-1.6-4-4v-36c0-2.4,1.6-4,4-4s4,1.6,4,4v36C184,372.4,182.4,374,180,374z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200,370c-2.4,0-4-1.6-4-4v-32c0-2.4,1.6-4,4-4s4,1.6,4,4v32C204,368.4,202.4,370,200,370z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M194,488h-44c-2.4,0-4-1.6-4-4s1.6-4,4-4h44c2.4,0,4,1.6,4,4S196.4,488,194,488z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230,488h-8c-2.4,0-4-1.6-4-4s1.6-4,4-4h8c2.4,0,4,1.6,4,4S232.4,488,230,488z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M364,508h-84c-2.4,0-4-1.6-4-4v-29.6c0-11.6,10.8-18.4,21.2-18.4h52c11.2,0,18.8,7.2,18.8,18.4V504 C368,506.4,366.4,508,364,508z M284,500h76v-25.6c0-6.4-4-10.4-10.8-10.4h-52c-6.4,0-13.2,4-13.2,10.4V500z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M323.2,398c-9.6,0-17.6-8-17.6-17.6s8-17.6,17.6-17.6s17.6,8,17.6,17.6S333.2,398,323.2,398z M323.2,370.8 c-5.2,0-9.6,4.4-9.6,9.6s4.4,9.6,9.6,9.6s9.6-4.4,9.6-9.6S328.8,370.8,323.2,370.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M340,462c-2.4,0-4-1.6-4-4v-30h-28v30c0,2.4-1.6,4-4,4s-4-1.6-4-4v-34c0-2.4,1.6-4,4-4h36c2.4,0,4,1.6,4,4v34 C344,460.4,342.4,462,340,462z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M312,426c-2.4,0-4-1.6-4-4v-32c0-2.4,1.6-4,4-4s4,1.6,4,4v32C316,424.4,314.4,426,312,426z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M332,426c-2.4,0-4-1.6-4-4v-28c0-2.4,1.6-4,4-4s4,1.6,4,4v28C336,424.4,334.4,426,332,426z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M312,374c-2.4,0-4-1.6-4-4v-36c0-2.4,1.6-4,4-4s4,1.6,4,4v36C316,372.4,314.4,374,312,374z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M332,370c-2.4,0-4-1.6-4-4v-32c0-2.4,1.6-4,4-4s4,1.6,4,4v32C336,368.4,334.4,370,332,370z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M326,488h-44c-2.4,0-4-1.6-4-4s1.6-4,4-4h44c2.4,0,4,1.6,4,4S328.4,488,326,488z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M362,488h-8c-2.4,0-4-1.6-4-4s1.6-4,4-4h8c2.4,0,4,1.6,4,4S364.4,488,362,488z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M257.2,285.6c-22,0-39.6-17.6-39.6-39.6s17.6-39.6,39.6-39.6s39.6,17.6,39.6,39.6S278.8,285.6,257.2,285.6z M257.2,214.4 c-17.6,0-31.6,14.4-31.6,31.6s14.4,31.6,31.6,31.6s31.6-14.4,31.6-31.6S274.4,214.4,257.2,214.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M344,260h-36c-1.2,0-2.4-0.4-2.8-1.2s-1.2-2-1.2-3.2v-2c0.4-2.8,0.4-4.4,0.4-6.4c0-26.8-21.2-48.4-47.6-48.4 s-47.6,21.6-47.6,48c0,2.4,0,4,0.4,7.2v1.2c0,1.2-0.4,2.4-1.2,3.2c-0.8,0.8-2,1.2-2.8,1.2h-38c-2.4,0-4-1.6-4-4V182c0-2.4,1.6-4,4-4 s4,1.6,4,4v70h29.6c0-1.6-0.4-3.2-0.4-5.2c0-30.8,24.8-56,55.6-56S312,216,312,247.2c0,1.6,0,3.2-0.4,4.8h27.6v-70c0-2.4,1.6-4,4-4 s4,1.6,4,4v74C348,258.4,346.4,260,344,260z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M314,308H150c-2.4,0-4-1.6-4-4s1.6-4,4-4h164c2.4,0,4,1.6,4,4S316.4,308,314,308z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M306,128H170c-2.4,0-4-1.6-4-4s1.6-4,4-4h136c2.4,0,4,1.6,4,4S308.4,128,306,128z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M346,128h-12c-2.4,0-4-1.6-4-4s1.6-4,4-4h12c2.4,0,4,1.6,4,4S348.4,128,346,128z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M362,308h-16c-2.4,0-4-1.6-4-4s1.6-4,4-4h16c2.4,0,4,1.6,4,4S364.4,308,362,308z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146,220h-32.8c-6.4,0-13.2-4.4-13.2-12c0-8,8.4-12,14-12h31.6c2.4,0,4,1.6,4,4s-1.6,4-4,4H114c-2,0-6,1.2-6,4s3.6,4,5.2,4 H146c2.4,0,4,1.6,4,4S148.4,220,146,220z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116,302c-2.4,0-4-1.6-4-4v-80c0-2.4,1.6-4,4-4s4,1.6,4,4v80C120,300.4,118.4,302,116,302z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132,302c-2.4,0-4-1.6-4-4v-80c0-2.4,1.6-4,4-4s4,1.6,4,4v80C136,300.4,134.4,302,132,302z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116,386c-2.4,0-4-1.6-4-4v-60c0-2.4,1.6-4,4-4s4,1.6,4,4v60C120,384.4,118.4,386,116,386z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132,386c-2.4,0-4-1.6-4-4v-60c0-2.4,1.6-4,4-4s4,1.6,4,4v60C136,384.4,134.4,386,132,386z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M132,424h-16c-6.8,0-12-5.2-12-12v-16c0-6.8,5.2-12,12-12h16c6.8,0,12,5.2,12,12v16C144,418.8,138.8,424,132,424z M116,392 c-2.4,0-4,1.6-4,4v16c0,2.4,1.6,4,4,4h16c2.4,0,4-1.6,4-4v-16c0-2.4-1.6-4-4-4H116z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M389.2,326c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16C405.6,318.8,398.4,326,389.2,326z M389.2,302c-4.4,0-8,3.6-8,8 s3.6,8,8,8s8-3.6,8-8S394,302,389.2,302z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M394.4,220H370c-2.4,0-4-1.6-4-4s1.6-4,4-4h24.4c2,0,5.6-1.2,5.6-4s-4-4-5.6-4H370c-2.4,0-4-1.6-4-4s1.6-4,4-4h24.4 c6.8,0,13.6,4.4,13.6,12S400.8,220,394.4,220z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M396,302c-2.4,0-4-1.6-4-4v-80c0-2.4,1.6-4,4-4s4,1.6,4,4v80C400,300.4,398.4,302,396,302z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M380,302c-2.4,0-4-1.6-4-4v-76c0-2.4,1.6-4,4-4s4,1.6,4,4v76C384,300.4,382.4,302,380,302z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M396,386c-2.4,0-4-1.6-4-4v-60c0-2.4,1.6-4,4-4s4,1.6,4,4v60C400,384.4,398.4,386,396,386z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M380,386c-2.4,0-4-1.6-4-4v-60c0-2.4,1.6-4,4-4s4,1.6,4,4v60C384,384.4,382.4,386,380,386z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M396,424h-16c-6.8,0-12-5.2-12-12v-16c0-6.8,5.2-12,12-12h16c6.8,0,12,5.2,12,12v16C408,418.8,402.8,424,396,424z M380,392 c-2.4,0-4,1.6-4,4v16c0,2.4,1.6,4,4,4h16c2.4,0,4-1.6,4-4v-16c0-2.4-1.6-4-4-4H380z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M204,182c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4s4,1.6,4,4v20C208,180.4,206.4,182,204,182z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M308,182c-2.4,0-4-1.6-4-4v-20c0-2.4,1.6-4,4-4s4,1.6,4,4v20C312,180.4,310.4,182,308,182z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtificial);
export default __webpack_public_path__ + "static/media/artificial.01c09df8320df9e37c80bcc9e10e84dc.svg";
export { ForwardRef as ReactComponent };